import React from 'react'
import ProductsHeader from '../../components/productsHeader/ProductsHeader'
import SingleProduct from '../../components/singleProduct/SingleProduct'

const ProductDetail = () => {
	return (
		<>
			<ProductsHeader />
			<SingleProduct />
		</>
	)
}

export default ProductDetail
